import { jwtDecode } from 'jwt-decode';

/** Reads the `email` claim without checking the signature, so only use it for display or hints */
export function readEmailFromToken(token: string): string | null {
  try {
    return jwtDecode<{ email?: string }>(token).email ?? null;
  } catch {
    return null;
  }
}
